import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconCrossThick = function IconCrossThick(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-cross-thick"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1214 12L19.7072 6.41422C19.9025 6.21896 19.9025 5.90238 19.7072 5.70711L18.293 4.2929C18.0977 4.09764 17.7812 4.09764 17.5859 4.2929L12.0001 9.87869L6.41433 4.2929C6.21906 4.09764 5.90248 4.09764 5.70722 4.2929L4.29301 5.70711C4.09774 5.90238 4.09774 6.21896 4.29301 6.41422L9.87879 12L4.29301 17.5858C4.09774 17.7811 4.09774 18.0976 4.29301 18.2929L5.70722 19.7071C5.90248 19.9024 6.21906 19.9024 6.41433 19.7071L12.0001 14.1213L17.5859 19.7071C17.7812 19.9024 18.0977 19.9024 18.293 19.7071L19.7072 18.2929C19.9025 18.0976 19.9025 17.7811 19.7072 17.5858L14.1214 12Z",
    fill: "currentColor"
  })));
};

export { IconCrossThick };
